import { menuPackageList } from '@/services/api-v3/menuPackage';
import { useState } from 'react';

export default () => {
  const [data, setData] = useState<API.MenuPackage[] | null>(null);
  const [valueEnum, setValueEnum] = useState<Record<string, string> | null>(null);
  const [valueOptions, setValueOptions] = useState<{ value: string; label: string }[]>([]);
  const fetch = async () => {
    const res = await menuPackageList({ pageSize: -1 });
    setData(res.data);
    setValueEnum(
      res.data?.reduce(
        (pre: Record<string, string>, curr: API.MenuPackage) => ({
          ...pre,
          [curr.id]: curr.name,
        }),
        {},
      ),
    );
    setValueOptions(
      res.data?.map((item: API.MenuPackage) => ({ value: item.id, label: item.name })),
    );
  };
  const reset = () => {
    setData(null);
    setValueEnum(null);
    setValueOptions([]);
  };
  return {
    fetch,
    reset,
    data,
    valueEnum,
    valueOptions,
  };
};
